export default __webpack_public_path__ + "static/media/img_bg.f178cf2c.png";